import { Text, Select } from "react_reusable_components";
import { ThreeRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import { customInputStyle as customSelectStyle } from "../CustomInput/CustomInput";

const selectStyle = {
  selectWidth: {
    width: variables.fullWidth,
    height: variables.mediumHeight,
  },
  style: { overflow: variables.unset, position: "relative" },
};

export default function CustomSelect({
  style,
  value,
  onChange,
  className,
  label,
  required,
  error,
  showSearch,
  placeholder,
  options,
  restStyle,
  customLabelStyle,
  type = "selectDropdown",
  ...props
}) {
  return (
    <ThreeRow
      style={selectStyle.style}
      topSection={
        label && (
          <Text
            style={{
              ...customSelectStyle.labelStyle,
              ...customLabelStyle,
            }}
          >
            {label}
            {required && (
              <Text style={customSelectStyle.requiredStyle}>&nbsp;*</Text>
            )}
          </Text>
        )
      }
      middleSection={
        <Select
          type={type}
          placeholder={placeholder}
          value={value || null}
          showSearch={showSearch}
          onChange={onChange}
          options={options}
          style={{
            ...selectStyle.selectWidth,
            ...restStyle,
          }}
          {...props}
        />
      }
      bottomSection={
        !!error && (
          <Text style={customSelectStyle.errorStyle} type="danger">
            {error}
          </Text>
        )
      }
    />
  );
}
